import { render, staticRenderFns } from "./notification-banners.vue?vue&type=template&id=040f4406&"
import script from "./notification-banners.vue?vue&type=script&lang=js&"
export * from "./notification-banners.vue?vue&type=script&lang=js&"
import style0 from "./notification-banners.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports